import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { formatPharmacyGroupName } from "../../utils/Helpers";

export const PharmacyGroupSelect = (props) => {
  const sortedOptions = [...new Set(props.options)].sort((a, b) => {
    const isANotListed = a === "contract_pharmacy";
    const isBNotListed = b === "contract_pharmacy";

    if (isANotListed !== isBNotListed) {
      return isBNotListed - isANotListed;
    }

    const isAInHouse = a === "in_house";
    const isBInHouse = b === "in_house";

    if (isAInHouse !== isBInHouse) {
      return isBInHouse - isAInHouse;
    }

    return a.localeCompare(b);
  });

  return (
    <Autocomplete
      disablePortal
      slotProps={{
        popper: {
          placement: "bottom",
          modifiers: [
            {
              name: "flip",
              enabled: false,
            },
            {
              name: "preventOverflow",
              options: {
                altAxis: true,
                altBoundary: true,
                padding: 12,
              },
            },
          ],
        },
      }}
      getOptionLabel={(opt) => formatPharmacyGroupName(opt ?? "")}
      renderInput={(params) => (
        <TextField
          variant="outlined"
          required
          label={props.label ?? "Pharmacy Group"}
          placeholder={props.placeholder ?? "Search and Choose Pharmacy Group"}
          {...params}
          InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
        />
      )}
      {...props}
      options={sortedOptions}
    />
  );
};
